import { Button } from "@bandwith/ui";
import { Link } from "@tanstack/react-router";
import { useSession } from "../lib/auth";

export function UserMenu() {
  const { session, signOut, isTestAuthEnabled, csrfToken } = useSession();
  const user = session?.user;

  if (user) {
    return (
      <div className="flex items-center gap-3">
        {user.image && (
          <img
            src={user.image}
            alt=""
            width={32}
            height={32}
            className="rounded-full"
          />
        )}
        <Button variant="secondary" onClick={signOut}>
          Sign Out
        </Button>
      </div>
    );
  }

  // In test mode, show sign-in page with credentials option
  // In production, directly trigger Google OAuth
  if (isTestAuthEnabled) {
    return (
      <Button variant="secondary" asChild>
        <Link to="/auth/signin">Sign In</Link>
      </Button>
    );
  }

  return (
    <form action="/api/auth/signin/google" method="POST" className="inline">
      <input type="hidden" name="csrfToken" value={csrfToken ?? ""} />
      <Button type="submit" variant="secondary" disabled={!csrfToken}>
        Sign In
      </Button>
    </form>
  );
}
